export enum LogicQuestionType {
    Skip = 'skip_question',
    Branch = 'branch_logic',
    Creening = 'creening_logic',
    OnlyDisplaySelectedChoice = 'only_display_selected_choice',
    DisplayOnTitle = 'display_answer_on_title',
}

export const LOGIC_MENU_ITEM_TEXT = {
    skip_question: {
        text_en: 'Skip Question',
        text_vi: 'Bỏ qua câu này',
    },
    creening_logic: {
        text_en: 'Creening Logic',
        text_vi: 'Kết thúc khảo sát nếu tích vào đáp án này',
    },
    branch_logic: {
        text_en: 'Branch Logic',
        text_vi: 'Điều kiện rẽ nhánh',
    },
    only_display_selected_choice: {
        text_en: 'Only Display Selected Choice',
        text_vi:
            'Đáp án ở câu hỏi này, sẽ lấy từ các đáp án đã được lựa chọn ở câu hỏi trước đó',
    },
    display_answer_on_title: {
        text_en: 'Display Answer on Title',
        text_vi:
            'Lấy đáp án đã được lựa chọn ở câu hỏi trước điền vào title của câu hỏi này',
    },
};

export const LOGIC_AVAILABLE_BY_QUESTION_TYPE = {
    textbox: [LogicQuestionType.Skip],
    number: [LogicQuestionType.Skip],
    date: [LogicQuestionType.Skip],
    dropdown: [
        LogicQuestionType.Skip,
        LogicQuestionType.Creening,
        LogicQuestionType.Branch,
        LogicQuestionType.OnlyDisplaySelectedChoice,
    ],
    textbox_recommend: [
        LogicQuestionType.Skip,
        LogicQuestionType.OnlyDisplaySelectedChoice,
    ],
    textbox_recommend_multi_choice: [
        LogicQuestionType.Skip,
        LogicQuestionType.OnlyDisplaySelectedChoice,
    ],
    checkbox: [
        LogicQuestionType.Skip,
        LogicQuestionType.Creening,
        LogicQuestionType.Branch,
        LogicQuestionType.OnlyDisplaySelectedChoice,
    ],
    single_choice: [
        LogicQuestionType.Skip,
        LogicQuestionType.Creening,
        LogicQuestionType.Branch,
        LogicQuestionType.OnlyDisplaySelectedChoice,
    ],
    score: [LogicQuestionType.Skip],
    slider_scale: [LogicQuestionType.Skip],
    rank: [LogicQuestionType.Skip, LogicQuestionType.OnlyDisplaySelectedChoice],
    score_star_half: [LogicQuestionType.Skip],
    score_star_full: [LogicQuestionType.Skip],
    emoji: [LogicQuestionType.Skip],
    matrix_checkbox: [
        LogicQuestionType.Skip,
        LogicQuestionType.Creening,
        LogicQuestionType.OnlyDisplaySelectedChoice,
    ],
    matrix_radio: [
        LogicQuestionType.Skip,
        LogicQuestionType.Creening,
        LogicQuestionType.OnlyDisplaySelectedChoice,
    ],
    matrix_text: [
        LogicQuestionType.Skip,
        LogicQuestionType.OnlyDisplaySelectedChoice,
    ],
    image: [LogicQuestionType.Skip],
    image_with_title: [LogicQuestionType.Skip],
};

export const LOGIC_AVAILABLE_BY_QUESTION_TYPE_LOGIC_PAGE = {
    // textbox: [LogicQuestionType.Skip],
    // number: [LogicQuestionType.Skip],
    // date: [LogicQuestionType.Skip],
    dropdown: [
        // LogicQuestionType.Skip,
        // LogicQuestionType.Creening,
        LogicQuestionType.Branch,
        // LogicQuestionType.OnlyDisplaySelectedChoice,
    ],
    // textbox_recommend: [
    //     LogicQuestionType.Skip,
    //     LogicQuestionType.OnlyDisplaySelectedChoice,
    // ],
    // textbox_recommend_multi_choice: [
    //     LogicQuestionType.Skip,
    //     LogicQuestionType.OnlyDisplaySelectedChoice,
    // ],
    checkbox: [
        // LogicQuestionType.Skip,
        // LogicQuestionType.Creening,
        LogicQuestionType.Branch,
        // LogicQuestionType.OnlyDisplaySelectedChoice,
    ],
    single_choice: [
        // LogicQuestionType.Skip,
        // LogicQuestionType.Creening,
        LogicQuestionType.Branch,
        // LogicQuestionType.OnlyDisplaySelectedChoice,
    ],
    // score: [LogicQuestionType.Skip],
    // slider_scale: [LogicQuestionType.Skip],
    // rank: [LogicQuestionType.Skip, LogicQuestionType.OnlyDisplaySelectedChoice],
    // score_star_half: [LogicQuestionType.Skip],
    // score_star_full: [LogicQuestionType.Skip],
    // emoji: [LogicQuestionType.Skip],
    // matrix_checkbox: [
    //     LogicQuestionType.Skip,
    //     LogicQuestionType.Creening,
    //     LogicQuestionType.OnlyDisplaySelectedChoice,
    // ],
    // matrix_radio: [
    //     LogicQuestionType.Skip,
    //     LogicQuestionType.Creening,
    //     LogicQuestionType.OnlyDisplaySelectedChoice,
    // ],
    // matrix_text: [
    //     LogicQuestionType.Skip,
    //     LogicQuestionType.OnlyDisplaySelectedChoice,
    // ],
    // image: [LogicQuestionType.Skip],
    // image_with_title: [LogicQuestionType.Skip],
};

export const generateScaleMenuItems = (
    start: number,
    end: number,
    step: number
) => {
    const items = [];
    for (let i = start; i <= end; i += step) {
        items.push(i);
    }
    return items;
};

export type QuestionLogic =
    | LogicQuestionType.Skip
    | LogicQuestionType.Branch
    | LogicQuestionType.Creening
    | LogicQuestionType.OnlyDisplaySelectedChoice
    | LogicQuestionType.DisplayOnTitle;

export enum QuestionType {
    Textbox = 'textbox',
    SingleChoice = 'single_choice',
    Checkbox = 'checkbox',
    Dropdown = 'dropdown',
    Date = 'date',
    Emoji = 'emoji',
    Number = 'number',
    Score = 'score',
    Rank = 'rank',
    MatrixRadio = 'matrix_radio',
    MatrixCheckbox = 'matrix_checkbox',
    MatrixText = 'matrix_text',
    SliderScale = 'slider_scale',
    Image = 'image',
    TextboxRecommend = 'textbox_recommend',
    TextboxRecommendMultiChoice = 'textbox_recommend_multi_choice',
    ImageWithTitle = 'image_with_title',
    ScoreStarFull = 'score_star_full',
    ScoreStarHalf = 'score_star_half',
}

export const comparisonOperators = [
    { label: '>', value: 'greater_than' },
    { label: '≥', value: 'greater_than_or_equal' },
    { label: '<', value: 'less_than' },
    { label: '≤', value: 'less_than_or_equal' },
];
